// extracted by mini-css-extract-plugin
export default {"desc":"desc--IWgGl","surroundingFacility":"surroundingFacility--PEnG_","table":"table--ILLE0","pieChart":"pieChart--MYDFC","markerAnimationScale":"markerAnimationScale--CvJwI"};